<div class="row">
  <div class="col">
    <div class="carousel-wrapper">

      <app-carousel-dashboard-placeholder *ngIf="loader.isActive()"></app-carousel-dashboard-placeholder>

      <div class="alert" role="alert" [ngClass]="dataStatus.errorCSS()" *ngIf="dataStatus.isFailed()">
        {{dataStatus.errorMessage}}
      </div>
      <div class="alert" role="alert" [ngClass]="dataStatus.infoCSS()" *ngIf="dataStatus.thereIsInfo()">
        {{dataStatus.infoMessage}}
      </div>

      <ngb-carousel #host *ngIf="newsStore.news.length > 0" (slide)="onSlide($event)">
        <ng-template ngbSlide [id]="i" *ngFor="let n of filterNews(); let i = index">

          <div *ngIf="isNewsTypeTable(n)" class="slide-type-table">
            <h3 class="table-title">
              {{n.title}}
            </h3>
            <div class="table-responsive">
              <table class="table">
                <thead class="thead-dark">
                <tr>
                  <th *ngFor="let header of getHeaders(n)">{{header}}</th>
                </tr>
                </thead>

                <tbody *ngFor="let record of getTableRecords(n)">
                <tr>
                  <td>
                    <a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: getIsinCode(record) }">
                      {{getIsinCode(record) ? getIsinCode(record) : '--'}}
                    </a>
                  </td>
                  <td *ngFor="let value of record.recordValues.slice(1)" [innerHTML]="value"></td>
                </tr>
                <tr>
                  <td [colSpan]="getHeaders(n).length">
                    <strong>Come funziona:</strong>
                    <div [innerHTML]="removeNbsp(record.description)"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div *ngIf="!isNewsTypeTable(n)" class="slide-type-image-text">
            <div class="picsum-img-wrapper">
              <img [src]="getCompleteImageUrl(n)" alt="Random first slide">
            </div>
            <div class="slide-text">
              <h3 class="title"><a (click)="goToArticle(n)">{{n.title}}</a></h3>
              <p class="description" [innerHTML]="newsTextPreview(n) | safeHtml"></p>
            </div>
          </div>

          <!-- ROTTA VETRINA MESE--->
          <div *ngIf="isNewsTypeVetrina(n)" class="slide-type-image-text">
            <div class="picsum-img-wrapper">
              <img [src]="getCompleteImageUrl(n)" alt="Random first slide">
            </div>
            <div class="slide-text">
              <h3 class="title"><a  [routerLink]="['/menu/vetrina-mese']">{{n.title}}</a></h3>
              <p class="description" [innerHTML]="newsTextPreview(n) | safeHtml"></p>
            </div>
          </div>

        </ng-template>
      </ngb-carousel>

    </div>
  </div>
</div>
